export default __webpack_public_path__ + "static/media/ParSaved.f5acf76b.gif";